import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";

import Answer from "./answer.tsx";
import {CARD_HEIGHT} from "./constants.ts";
import Field from "./field.tsx";
import type {AnswerKey, BlooketQuestion} from "./types.ts";
import {ANSWER_KEYS, getDuplicateKeys} from "./utils.ts";

interface Props {
    card: BlooketQuestion | null;
    setCard: (value: BlooketQuestion) => void;
}

const QuestionContent: React.FC<Props> = (props) => {
    const blank: BlooketQuestion = {
        prompt: "",
        answerKey: "A",
        answers: {A: "", B: "", C: "", D: ""},
    };
    const question: BlooketQuestion = props.card ?? blank;

    const setAnswers = (answers: Record<AnswerKey, string>): void => {
        props.setCard({
            ...question,
            answers,
        });
    };
    const setAnswerKey = (answerKey: AnswerKey): void => {
        props.setCard({
            ...question,
            answerKey,
        });
    };
    const setQuestionText = (questionText: string): void => {
        props.setCard({
            ...question,
            prompt: questionText,
        });
    };

    const duplicateKeys = getDuplicateKeys(question);
    return (
        <View style={styles.cardContent}>
            <Field
                text={question.prompt}
                setText={setQuestionText}
                style={styles.questionField}
                ariaLabel={t`Question`}
            />
            <View role="radiogroup">
                {ANSWER_KEYS.map((key, index) => (
                    <Answer
                        key={index}
                        letter={key}
                        text={question.answers[key]}
                        setText={(s) => {
                            setAnswers({...question.answers, [key]: s});
                        }}
                        isCorrect={question.answerKey === key}
                        setAnswerKey={setAnswerKey}
                        isDuplicate={duplicateKeys.has(key)}
                    />
                ))}
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    cardContent: {
        padding: spacing.small_12,
        paddingBlockStart: spacing.xxxSmall_4,
        display: "flex",
        flexGrow: 2,
        flexBasis: CARD_HEIGHT,
    },
    questionField: {
        fontWeight: "bold",
        fontSize: 16,
        flexBasis: 80,
    },
});

export default QuestionContent;
